import React from 'react';
import {Dialog} from 'primereact/dialog';

import styles from './auth.module.css';
import {SignInForm} from '../../domains/signInForm';
import {useAuth} from './auth-provider';

export const SignInDialog = () => {
  const {
    signinVisible,
    closeSignInModal,
  } = useAuth();

  return (
    <Dialog
      header="Войдите в личный кабинет"
      visible={signinVisible}
      style={{width: '50vw'}}
      onHide={() => {
        if (!signinVisible) return;
        closeSignInModal();
      }}
      pt={{
        header: {
          className: styles.cardWrapper,
        },
        content: {
          className: styles.cardWrapper,
        },
        footer: {
          className: styles.cardWrapper,
        },
      }}
    >
      <SignInForm />
    </Dialog>
  );
}
